<template>
  <div>
    <div class="box" v-if="showContent">
      <div class="box">
        <ContentLoading
          :show="showContent"
          :grid="grid"
          :width="300"
          :height="80"
          :mobile-grid="mobileGrid"
          :mobile-width="30"
          :mobile-height="20"
        />
      </div>
      <ContentLoading
        :show="showContent"
        :grid="gridCard"
        :width="300"
        :height="100"
        :mobile-grid="mobileGridCard"
        :mobile-width="30"
        :mobile-height="40"
      />
    </div>
    <Form v-else title="Alterar segmentação" :data="data" @submit="submit" />
  </div>
</template>

<script>
import Form from './components/Form'
import { getSegment, updateSegment } from '@/services/segments'
import { mapGetters } from 'vuex'
import { orderBy } from 'lodash'
import moment from 'moment'
// import config from '@/config'
import ContentLoading from '@/components/helpers/ContentLoading'

export default {
  name: 'SegmentsCreate',
  components: {
    Form,
    ContentLoading
  },
  data: () => ({
    show: true,
    data: null,
    showContent: true,
    grid: [
      { x: 135, y: 25, rx: 0, ry: 0, innerWidth: 35, innerHeight: 3 },
      { x: 140, y: 30, rx: 0, ry: 0, innerWidth: 25, innerHeight: 3 },
      { x: 132, y: 40, rx: 1, ry: 1, innerWidth: 40, innerHeight: 10 },
    ],
    mobileGrid: [
      { x: 10, y: 0, rx: 1, ry: 1, innerWidth: 20, innerHeight: 3 },
      { x: 15, y: 5, rx: 1, ry: 1, innerWidth: 15, innerHeight: 3 },
      { x: 0, y: 10, rx: 1, ry: 1, innerWidth: 30, innerHeight: 7 }
    ],
    gridCard: [
      { x: 5, y: 0, rx: 2, ry: 2, innerWidth: 60, innerHeight: 100 }
    ],
    mobileGridCard: [
      { x: 5, y: 0, rx: 2, ry: 2, innerWidth: 20, innerHeight: 30 }
    ]
  }),
  computed: {
    ...mapGetters(['getToken'])
  },
  methods: {
    async submit(payload) {
      this.showContent = true
      try {
        const { id } = this.$route.params
        await updateSegment(id, payload)
        this.$router.push('/')
        this.$swalModal(
          'Sucesso',
          'Segmentação atualizada com sucesso!',
          'success'
        )
        this.showContent = false
      } catch (error) {
        this.$swalModal(
          'Erro',
          'Não foi possível atualizar essa segmentação!',
          'error'
        )
      }
    },
    formatDate(item) {
      const { dateParse } = this
      const { value } = item
      const newDate = value instanceof Array ? value.map((v, k) => dateParse(item, v, k)) : dateParse(item, value)
      return newDate
    },
    dateParse(item, value) {
      const { datetimeOption = 'date' } = item
      const formats = {
        datetime: () => ({
          in: `YYYY-MM-DD HH:mm:ss'}`,
          out: 'DDMMYYYYHHmm'
        }),
        date: () => ({
          in: 'YYYY-MM-DD',
          out: 'DDMMYYYY'
        }),
        time: () => ({
          in: 'HHmm',
          out: 'HHmm'
        })
      }
      const format = formats[datetimeOption]()
      return format ? moment(value, format.in).format(format.out) : value
    },
  },
  async created() {
    try {
      // if (this.getToken === config.tokenFrame || true) {
        const { id } = this.$route.params
        const response = await getSegment({ id })
        const data = response.data
        const groups = data.groups.map(({ props, events, ...group }) => ({
          ...group,
          items: orderBy([
            ...props,
            ...events
          ], 'position', 'asc')
        }))

        this.data = {
          ...data,
          groups: groups.map(({ items, ...group }) => ({
            ...group,
            items: items.map(item => ({
              ...item,
              value: item.format === 'DATE' || 
                item.format === 'DATETIME' ? 
                this.formatDate(item) :
                item.value
            }))
          }))
        }
      // }
    } catch (error) {
      console.log({ error })
    } finally {
      this.showContent = false
    }
  }
}
</script>

<style>
</style>
